import { useState, useEffect } from 'react';
import './ParkingContainer.scss';

import header1920 from '@icons/headerImages/pngs/header1920.png';
import header1680 from '@icons/headerImages/pngs/header1680.png';
import header1440 from '@icons/headerImages/pngs/header1440.png';
import header1366 from '@icons/headerImages/pngs/header1366.png';
import header1080 from '@icons/headerImages/pngs/header1080.png';
import header1024 from '@icons/headerImages/pngs/header1024.png';
import header820 from '@icons/headerImages/pngs/header820.png';
import header768 from '@icons/headerImages/pngs/header768.png';
import header425 from '@icons/headerImages/pngs/header425.png';
import header375 from '@icons/headerImages/pngs/header375.png';
import GuestPayHeader from '../../GuestPay/screens/GuestPayHeader';

const ParkingContainer = ({ Component }) => {
    const [headerImage, setHeaderImage] = useState();

    useEffect(() => {
        const handleResize = () => {
            if (window.screen.width >= 1920) {
                setHeaderImage(header1920);
            } else if (window.screen.width <= 1920 && window.screen.width >= 1680) {
                setHeaderImage(header1680);
            } else if (window.screen.width > 1680 && window.screen.width <= 1440) {
                setHeaderImage(header1440);
            } else if (window.screen.width > 1440 && window.screen.width <= 1366) {
                setHeaderImage(header1366);
            } else if (window.screen.width > 1366 && window.screen.width <= 1080) {
                setHeaderImage(header1080);
            } else if (window.screen.width > 1080 && window.screen.width <= 1024) {
                setHeaderImage(header1024);
            } else if (window.screen.width > 1024 && window.screen.width <= 820) {
                setHeaderImage(header820);
            } else if (window.screen.width > 820 && window.screen.width <= 768) {
                setHeaderImage(header768);
            } else if (window.screen.width > 768 && window.screen.width <= 425) {
                setHeaderImage(header425);
            } else if (window.screen.width > 425 && window.screen.width <= 375) {
                setHeaderImage(header375);
            } else if (window.screen.width <= 375) {
                setHeaderImage(header375);
            } else {
                setHeaderImage(header1920);
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className="min-vh-100 d-flex flex-column" style={{ gap: '20px' }}>
            <GuestPayHeader />
            {/* <img className="image-setting" src={headerImage} alt="" />
            <div className="parking-container">{Component}</div> */}
            <div className="container custom d-flex align-items-start justify-content-center py-4">
                <div className="card border-0 custom-shadow w-100" style={{ maxWidth: '520px', borderRadius: '12px' }}>
                    <div className="card-body p-1" style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        {/* Content section */}
                        <div className="mb-4">{Component}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ParkingContainer;
